import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";

export const useEmailEdit = () => {
  const dispatch = useDispatch();
  const { navigateToPage } = useNavigation();

  const handleEmailEdit = useCallback(
    (email: string, emailConfirmation: string) => {
      dispatch(appActions.showLoading());
      dispatch(
        authActions.sendChangeEmail.started({
          email,
          email_confirmation: emailConfirmation,
          // TODO: change to selected language
          lang: "ja",
          onComplete: () => dispatch(appActions.hideLoading()),
          onSuccess: () => navigateToPage(PageRoutes.CHANGE_EMAIL_MESSAGE),
        }),
      );
    },
    [],
  );

  return { handleEmailEdit };
};
